export default "dist/images/block-testimonial-background.3dcb464.png";